import {
  DataTypeOption,
  FIELD_DATA_TYPE_CONFIG_DEFAULT,
  FIELDS_UI_LABELS,
} from '../components/fields/FieldsSettings/FieldsSettingsTypes';

/**
 * Function to get the default or selected format for a given data type.
 * This function is useful for deciding how to display a particular type of data,
 * either based on user-defined settings or default settings.
 *
 * @param {string} [dataType] - The type of the data, e.g., 'date', 'amount', 'number'.
 * @param {DataTypeOption | null} [dataFormat] - The selected or default format settings for the data type.
 *
 * @returns {string} - Returns the UI label corresponding to the selected or default format.
 */
export const getDataFormat = (dataType?: string, dataFormat?: DataTypeOption | null) => {
  // If the data format is inherited, return the default format for the given data type.
  if (dataFormat?.inherited === true) {
    return FIELD_DATA_TYPE_CONFIG_DEFAULT[dataType as keyof typeof FIELD_DATA_TYPE_CONFIG_DEFAULT];
  }

  // Otherwise, return the UI label for the selected format, or an empty string if none exists.
  return FIELDS_UI_LABELS[dataFormat?.order ?? dataFormat?.decimalSymbol ?? ''] ?? '';
};
